import { useState } from 'react';
import { NavLink, Link } from 'react-router-dom';
import SafeIcon from '../common/SafeIcon';
import { site } from '../data/site';
import './guest-updates.css';

export default function Header() {
  const [open, setOpen] = useState(false);
  const closeMenu = () => setOpen(false);

  return (
    <header className="site-header">
      <div className="header-inner">
        <Link className="brand" to="/" onClick={closeMenu} aria-label="K and son’s Guest House home">
          <img className="brand-logo" src={site.logo} alt="K and son’s Guest House logo" width="62" height="62" />
        </Link>
        <button
          className="menu-toggle"
          type="button"
          onClick={() => setOpen(!open)}
          aria-expanded={open}
          aria-label={open ? 'Close navigation menu' : 'Open navigation menu'}
        >
          <SafeIcon name={open ? 'X' : 'Menu'} />
        </button>
        <nav className={`main-nav${open ? ' is-open' : ''}`} aria-label="Main navigation">
          {site.nav.map((item) => (
            <NavLink key={item.to} to={item.to} end={item.to === '/'} onClick={closeMenu}>
              {item.label}
            </NavLink>
          ))}
          <Link className="button button-gold nav-booking" to="/booking" onClick={closeMenu}>Book Your Stay</Link>
        </nav>
        <Link className="button button-gold desktop-booking" to="/booking">Book Your Stay</Link>
      </div>
    </header>
  );
}